import { IEntity } from '@pf/shared-common';
import {
    EquipmentFragment,
    PutAwayListSearchRequestParams,
    PutAwayListViewModelCreateBody,
    PutAwayListViewModelRead,
    PutAwayViewModelRead,
    ResourceAuth,
    WarehouseFragment,
} from '@control-tower/platform-wms';
import { IWarehouseEntity } from '../interfaces/warehouse-entity';

export type PutAwayListRead = PutAwayListViewModelRead &
    IEntity & { putAways: PutAwayViewModelRead[] };
export type PutAwayListCreate = PutAwayListViewModelCreateBody;
export type PutAwayListSearchParams = PutAwayListSearchRequestParams;

export type PutAwayLineRead = PutAwayViewModelRead & IEntity;

export class PutAwayListDto implements IWarehouseEntity {
    constructor(data: Partial<PutAwayListDto>) {
        Object.assign(this, data);
    }

    id!: string;
    warehouse!: WarehouseFragment;
    warehouseId?: string;

    assignedTo?: string | null;
    putAwayByDate?: string;
    organizedBy?: string | null;
    status?: string | null;
    putAways?: PutAwayViewModelRead[];

    get name(): string {
        return `${this.status} - ${this.putAwayByDate}`;
    }

    resourceAuth?: ResourceAuth;
    createdDate?: string;
    modifiedDate?: string;
    isDeleted?: boolean;

    equipmentId?: string;
    equipment?: EquipmentFragment;
}
